'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var prosemirrorState = require('prosemirror-state');
var index_js = require('../utils/index.js');
var index_js$1 = require('../cursor/index.js');
var keymap = _interopDefault(require('../keymap/index.js'));
var preact = require('preact');

const FONT_COLOR_DARK = "#333";
const FONT_COLOR_LIGHT = "#fff";
const colorsMore = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
const colors = ["#ccc", "#f5222d", "#fadb14", "#52c41a", "#1890ff"];
const patterns = [{
  type: "fill",
  text: "填充"
}, {
  type: "outline",
  text: "线框"
}];
const colorsMap = {
  gray: "#ccc",
  red: "#f5222d",
  yellow: "#fadb14",
  green: "#52c41a",
  blue: "#1890ff"
};

const formatOldValue = (color = "") => {
  if (colorsMap[color]) {
    return colorsMap[color];
  }

  return color;
};

const computeFontColor = color => {
  const index = colorsMore.findIndex(c => c === color);

  if (index === -1) {
    return FONT_COLOR_DARK;
  }

  if (index % 12 < 1) {
    return FONT_COLOR_DARK;
  }

  if (index % 12 < 2) {
    return FONT_COLOR_LIGHT;
  }

  if (index > 11 && index < 36) {
    return FONT_COLOR_DARK;
  }

  return FONT_COLOR_LIGHT;
};

const computeStyle = (color, pattern) => {
  return `
    background: ${pattern === "fill" ? color : "#fff"};
    border-color: ${color};
    color: ${pattern === "fill" ? computeFontColor(color) : ""};
  `;
};
const createNodeView = node => {
  const dom = document.createElement("span");
  const {
    color,
    pattern
  } = node.attrs;
  dom.setAttribute("class", "ct-status");
  dom.setAttribute("style", computeStyle(color, pattern));
  dom.setAttribute("spellcheck", "false");
  return {
    dom,
    contentDOM: dom
  };
};

const schema = {
  nodes: {
    status: {
      group: "inline",
      content: "text*",
      inline: true,
      defining: true,
      allowGapCursor: true,
      braceWidth: 90,
      attrs: {
        pattern: {
          default: "fill"
        },
        color: {
          default: "#ccc"
        },
        expand: {
          default: false
        },
        input: {
          default: false
        },
        selectedkey: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'span[class~="ct-status"]',
        getAttrs: dom => {
          const color = formatOldValue(dom.getAttribute("data-color"));
          return {
            color,
            pattern: dom.getAttribute("data-pattern"),
            expand: !colors.includes(color)
          };
        }
      }],

      toDOM(node) {
        const {
          pattern,
          color
        } = node.attrs;
        const nodeAttrs = {
          "class": "ct-status",
          "data-pattern": pattern,
          "data-color": color
        };
        return ["span", nodeAttrs, 0];
      }

    }
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function insert() {
  return function (state, dispatch, view, trigger) {
    const {
      tr,
      schema,
      selection
    } = state;
    const {
      $from,
      from
    } = selection;
    const {
      status
    } = schema.nodes;

    if (!index_js.canInsertTypes(state)) {
      return false;
    }

    const selectedkey = index_js.uuid();
    const node = status.create({
      input: true,
      selectedkey
    }, schema.text("\u200B"));
    const plus = $from.parent.type.name === "link" ? 3 : 2;
    tr.replaceWith(from, from, node);
    const newSelection = prosemirrorState.TextSelection.create(tr.doc, from + plus);
    tr.setSelection(newSelection);
    dispatch(tr.scrollIntoView());

    if (typeof trigger === "function") {
      trigger("afterInsert", {
        braceWidth: 90
      });
    }

    view.focus();
    return true;
  };
} // 设置选区内状态属性

function setAttrs(attrs, outSelection) {
  return function (state, dispatch, view) {
    const {
      tr,
      schema
    } = state;
    const {
      from,
      to
    } = outSelection;
    const status = schema.nodes.status;
    index_js.setBetweenAttrs(from, to, tr, node => node.type === status, oldAttrs => objectSpread({}, oldAttrs, attrs));
    tr.setSelection(outSelection);
    dispatch(tr);
    view.focus();
    return true;
  };
}

let lastSelectStatus = null;

const nodeAssert = status => node => node.type === status;

const domAssert = dom => dom && dom.classList && dom.classList.contains("ct-status");

const pluginKey = new prosemirrorState.PluginKey("status");
function createPlugin(store) {
  return new prosemirrorState.Plugin({
    key: pluginKey,
    props: {
      handleClick: () => {
        store.hidePopover();
      },
      handleClickOn: (view, pos, node, nodePos) => {
        const {
          dispatch,
          state
        } = view;
        const {
          schema,
          tr,
          selection
        } = state;
        const {
          status
        } = schema.nodes;

        try {
          if (selection && node.type.name === status.name) {
            if (!lastSelectStatus) {
              const newSelection = prosemirrorState.NodeSelection.create(tr.doc, nodePos);
              tr.setSelection(newSelection);
              dispatch(tr);
            } else if (lastSelectStatus.selectedkey === node.attrs.selectedkey) {
              let newPos = pos;
              const nodeBefore = selection.$from.nodeBefore;

              if (!nodeBefore) {
                // 此时光标在零宽字符前，需修正
                newPos += 1;
              }

              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));

              if (tr.selection.node || tr.selection.$from.parent.type.name !== status.name) {
                // 没有正确定位到里
                tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos - 1));
              }

              view.dispatch(tr);
              view.focus();
            }

            return true;
          }
        } catch (err) {
          console.error(err);
        }
      },
      transformPastedHTML: html => html.replace(/(class="ct-status"[^>]*>(?!\u200B))/g, "$1\u200B"),
      // 双击进入编辑
      handleDoubleClick: (view, _pos, e) => {
        const {
          state,
          dispatch
        } = view;
        const {
          tr,
          doc,
          schema,
          selection
        } = state;
        const {
          status
        } = schema.nodes;
        const foundNode = index_js.findParentNode(state.selection.$from.path, nodeAssert(status));
        const statusDOM = index_js.findParentDOM(e.target, domAssert);
        let pos = null;

        if (foundNode && statusDOM) {
          pos = foundNode.pos;
        } else if (statusDOM) {
          pos = view.docView.posFromDOM(statusDOM) - 1 - statusDOM.textContent.length;
        }

        const {
          node
        } = selection;

        if (pos && node) {
          // const selection = NodeSelection.create(doc, pos);
          // const { from, to, node } = selection;
          // setBetweenAttrs(from, to, tr, nodeAssert(status), attrs => ({ ...attrs, input: true }));
          tr.setSelection(prosemirrorState.TextSelection.create(doc, pos + node.nodeSize - 1));
          dispatch(tr);
          return true;
        }

        return false;
      },
      handleDOMEvents: {
        cut: (view, event) => {
          const {
            selection,
            schema,
            tr
          } = view.state;
          const {
            status
          } = schema.nodes;
          const {
            $from,
            $to,
            from,
            to
          } = selection;
          const selectStatusFrom = $from.parent && $from.parent.type === status && $from.parent;
          const selectStatusTo = $to.parent && $to.parent.type === status && $to.parent;
          const statusNode = selectStatusFrom || selectStatusTo;
          const rangeSize = Math.abs(to - from) + 3;

          if ((selectStatusFrom || selectStatusTo) && rangeSize >= statusNode.nodeSize) {
            try {
              let pos = [];

              if (rangeSize === statusNode.nodeSize) {
                pos = [from - 2, to + 1]; // 选中状态宏
              } else if (selectStatusFrom) {
                pos = [from - 2, to]; // 从后往前选，状态宏在最前
              } else if (selectStatusTo) {
                pos = [from, to + 1]; // 从前往后选，状态宏在最后
              }

              const newSelection = prosemirrorState.TextSelection.create(tr.doc, ...pos);
              view.dispatch(tr.setSelection(newSelection));
            } catch (err) {
              console.error(err);
            }
          }
        },
        drop: () => {
          store.hidePopover(false);
        },
        keydown: (view, e) => {
          const {
            state,
            dispatch
          } = view;
          const {
            tr,
            schema,
            selection
          } = state;
          const {
            from,
            $from,
            to
          } = selection;
          const status = schema.nodes.status;
          const node = selection.node;
          const keyCode = e.keyCode || e.which;

          if (keyCode === 8) {
            return false;
          } // 此时为选中状态宏，非中文输入法时覆盖原有内容


          if (node && node.type === status) {
            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2, from + node.nodeSize - 1));
            dispatch(tr);
          } else if ($from.parent && $from.parent.type === status && !$from.nodeBefore) {
            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1, to));
            dispatch(tr);
          }
        },
        mousedown: view => {
          const {
            selection,
            schema
          } = view.state;
          const {
            status
          } = schema.nodes;
          let selectedNode = selection && selection.$from.parent;

          if (selectedNode && selectedNode.type.name !== status.name || selection.node) {
            selectedNode = selection.node;
          }

          if (selectedNode && selectedNode.type.name === status.name) {
            if (lastSelectStatus && lastSelectStatus.selectedkey !== selectedNode.attrs.selectedkey) {
              lastSelectStatus = null;
            } else {
              lastSelectStatus = {
                selectedkey: selectedNode.attrs.selectedkey
              };
            }
          } else {
            lastSelectStatus = null;
          }

          return false;
        }
      },
      nodeViews: {
        status: node => createNodeView(node)
      }
    },
    view: view => new index_js.Popover({
      view,
      store,
      height: 76,
      className: "ct-status-popover",
      bottomFirst: true,
      sticky: false,
      getToolboxHeightFn: () => {
        if (store.node && store.node.attrs.expand) {
          return 170;
        }

        return 76;
      }
    })
  });
}

function checkZero(text) {
  return text === "\u200B";
}

function isSelectStatus() {
  const selection = window.getSelection();
  return selection.focusNode && selection.focusNode.classList && selection.focusNode.classList.contains("ct-status");
}

function handleBackspace(state, dispatch, view) {
  const {
    tr,
    schema,
    selection
  } = state;
  const status = schema.nodes.status;
  const {
    $cursor,
    $from,
    from,
    to
  } = selection;
  const statusInfo = index_js.findParentNode($from.path, node => node.type === status);

  if (statusInfo) {
    if ($cursor) {
      const cursorNodeBefore = $cursor.nodeBefore;
      const isZeroBefore = cursorNodeBefore && checkZero(cursorNodeBefore.text);

      if (isZeroBefore || !cursorNodeBefore) {
        // 光标在状态宏内最前端时不删除状态宏
        return true;
      }
    } else {
      const isFocusStatus = isSelectStatus();
      const {
        nodeBefore
      } = $from;
      let trueFrom = from;

      if (!isFocusStatus) {
        // 拖动选中了文字
        if (!nodeBefore) {
          trueFrom += 1; // 选中了零宽字符要少删一个字符
        }

        tr.delete(trueFrom, to);
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, trueFrom));
        dispatch(tr);
        view.focus();
        return true;
      } else if (!nodeBefore) {
        dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, trueFrom + 1, to)));
        return false;
      }
    }
  } // else if (selection.node && selection.node.type.name === status.name) {
  //   // 此时为选中状态宏整个删除
  //   tr.setSelection(NodeSelection.create(tr.doc, from - 2));
  //   dispatch(tr.deleteSelection());
  //   view.focus();
  //   return true;
  // }


  if ($cursor) {
    const textPos = from - 3;

    if (textPos < 0) {
      return false;
    }

    const textNode = tr.doc.nodeAt(textPos);

    if (textNode && textNode.type.name === "text") {
      const statusPos = textPos - textNode.nodeSize;

      if (statusPos < 0) {
        return false;
      }

      const statusNode = tr.doc.nodeAt(statusPos);

      if (statusNode && statusNode.type === status) {
        tr.delete(from - 1, from);
        const newSelection = new index_js$1.GapCursor(tr.doc.resolve(from - 1));
        dispatch(tr.setSelection(newSelection));
        return true;
      }
    }
  }

  return false;
}
const handleEnter = (state, dispatch, view) => {
  const {
    tr,
    schema,
    selection
  } = state;
  const {
    $from
  } = selection;
  const status = schema.nodes.status;
  const foundNode = index_js.findParentNode($from.path, node => node.type === status);

  if (foundNode) {
    const {
      node,
      pos
    } = foundNode;
    const newSelection = prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize + 1);
    dispatch(tr.setSelection(newSelection));
    view.focus();
    return true;
  }

  return false;
};

const ColorPicker = ({
  className = "",
  colors,
  selected,
  onChange
}) => preact.h("div", {
  className: `color-group ${className}`
}, colors.map(color => preact.h("div", {
  key: color,
  className: `item${color === selected ? " selected" : ""}`,
  onClick: () => onChange(color)
}, preact.h("div", {
  style: {
    backgroundColor: color
  }
}))));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-status-expand{display:flex;align-items:center}.ct-status-expand-btn{display:flex;width:26px;height:26px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExIDIxYTMgMyAwIDEgMSAwIDYgMyAzIDAgMCAxIDAtNnptMTMgMGEzIDMgMCAxIDEgMCA2IDMgMyAwIDAgMSAwLTZ6bTEzIDBhMyAzIDAgMSAxIDAgNiAzIDMgMCAwIDEgMC02eiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+\") 50% no-repeat;background-size:16px 16px;cursor:pointer;margin:0 1px 0 -5px}";
styleInject(css);

class Expand extends preact.Component {
  constructor(props) {
    super(props);

    this.handleClick = () => {
      const {
        onExpand = () => null
      } = this.props;
      this.setState({
        expand: true
      });
      onExpand();
    };

    this.state = {
      expand: !!props.expand
    };
  }

  render() {
    const {
      className = "",
      child,
      children
    } = this.props;
    const {
      expand
    } = this.state;
    return preact.h("div", {
      className: `ct-status-expand ${className}`
    }, expand ? child : children, expand ? null : preact.h("div", {
      className: "ct-status-expand-btn",
      onClick: () => this.handleClick()
    }));
  }

}

const PatternPicker = ({
  className = "",
  patterns,
  selected,
  onChange
}) => preact.h("div", {
  className: `pattern-group ${className}`
}, patterns.map(p => preact.h("label", {
  className: "radio",
  key: p.type,
  onClick: () => onChange(p.type)
}, preact.h("span", {
  className: "radio-bg"
}), preact.h("input", {
  type: "radio",
  checked: selected === p.type
}), " ", p.text, preact.h("span", {
  className: "radio-on"
}))));

var css$1 = ".ct-toolbox.ct-status-editor{flex-direction:column;align-items:flex-start}.ct-toolbox.ct-status-editor .ct-status-editor-expand{display:flex;flex-direction:row}.ct-toolbox.ct-status-editor .color-group{height:38px;display:flex;justify-content:center;align-items:center}.ct-toolbox.ct-status-editor .color-group .item{width:26px;height:26px;margin:0 2px;display:flex;justify-content:center;align-items:center;cursor:pointer}.ct-toolbox.ct-status-editor .color-group .item.selected,.ct-toolbox.ct-status-editor .color-group .item:hover{border:1px solid #ccc;border-radius:2px}.ct-toolbox.ct-status-editor .color-group .item:first-child{margin:0 2px 0 4px}.ct-toolbox.ct-status-editor .color-group .item div{width:14px;height:14px}.ct-toolbox.ct-status-editor .color-group-large{width:244px;height:106px;flex-wrap:wrap;margin:9px 6px}.ct-toolbox.ct-status-editor .color-group-large .item{width:16px;height:16px;border:1px solid #eee;margin:1px 2px 0}.ct-toolbox.ct-status-editor .color-group-large .item.selected,.ct-toolbox.ct-status-editor .color-group-large .item:hover{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-toolbox.ct-status-editor .color-group-large .item:hover{z-index:3}.ct-toolbox.ct-status-editor .color-group-large .item:first-child{margin:1px 2px 0}.ct-toolbox.ct-status-editor .pattern-group{height:38px;display:flex;justify-content:center;align-items:center;margin-left:12px}.ct-toolbox.ct-status-editor .pattern-group.large{margin-bottom:8px}.ct-toolbox.ct-status-editor .pattern-group .radio{display:inline-block;position:relative;font-size:14px;line-height:16px;margin-right:12px;cursor:pointer}.ct-toolbox.ct-status-editor .pattern-group .radio input{display:none}.ct-toolbox.ct-status-editor .pattern-group .radio .radio-bg{display:inline-block;height:16px;width:16px;margin-right:5px;padding:0;border-radius:100%;border:1px solid #00a7cd;vertical-align:top;cursor:pointer;transition:all .2s ease}.ct-toolbox.ct-status-editor .pattern-group .radio .radio-on{display:none}.ct-toolbox.ct-status-editor .pattern-group .radio input:checked+span.radio-on{width:8px;height:8px;position:absolute;border-radius:100%;background:#00a7cd;top:4px;left:4px;transition:all .2s ease;-webkit-transform:scale(1);transform:scale(1);display:inline-block}";
styleInject(css$1);

class StatusEditor extends preact.Component {
  constructor(props) {
    super(props);

    this.handleClick = e => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    };

    this.handleExpand = () => {
      this.setState({
        expand: true
      });
      this.props.handleExpand();
    };

    this.state = {
      expand: props.expand
    };
  }

  render() {
    const {
      color,
      pattern,
      handleColorSelect,
      handlePatternSelect
    } = this.props;
    const {
      expand
    } = this.state;
    return preact.h("div", {
      className: "ct-status-editor",
      onClick: this.handleClick
    }, preact.h(Expand, {
      className: "ct-status-editor-expand",
      expand: expand,
      onExpand: () => this.handleExpand(),
      child: preact.h(ColorPicker, {
        className: "color-group-large",
        colors: colorsMore,
        selected: color,
        onChange: c => handleColorSelect(c, expand)
      })
    }, preact.h(ColorPicker, {
      colors: colors,
      selected: color,
      onChange: c => handleColorSelect(c, expand)
    })), preact.h(PatternPicker, {
      className: expand ? "large" : "",
      patterns: patterns,
      selected: pattern,
      onChange: p => handlePatternSelect(p, expand)
    }));
  }

}

class StatusStore {
  constructor() {
    this.color = "gray";
    this.pattern = "fill";
    this.pluginName = "status";
    this.node = null;

    this.showPopover = node => {
      this.node = node;
      this.ctPopover.show({
        dom: this.node.dom,
        content: this.getToolbar(node.attrs)
      });
    };

    this.hidePopover = () => {
      this.ctPopover.hide();
    };

    this.handleColorSelect = (color, exp) => {
      const expand = exp || !colors.includes(color);
      const dom = this.setAttrs({
        color,
        expand
      });
      this.color = color;
      this.node.dom = dom;
      const node = {
        dom,
        pos: this.node.pos,
        attrs: this.node.attrs
      };
      this.hidePopover();
      this.showPopover(node);
    };

    this.handlePatternSelect = (pattern, expand) => {
      const dom = this.setAttrs({
        pattern,
        expand
      });
      this.pattern = pattern;
      this.node.dom = dom;
      const node = {
        dom,
        pos: this.node.pos,
        attrs: this.node.attrs
      };
      this.hidePopover();
      this.showPopover(node);
    };

    this.handleExpand = () => {
      const dom = this.setAttrs({
        expand: true
      });
      this.node.dom = dom;
      const node = {
        dom,
        pos: this.node.pos,
        attrs: this.node.attrs
      };
      this.hidePopover();
      this.showPopover(node);
    };

    this.setAttrs = newAttrs => {
      if (!this.node) {
        return;
      }

      const {
        state,
        dispatch
      } = this.editor.view;
      const {
        tr
      } = state;
      const {
        pos
      } = this.node;

      try {
        const attrs = objectSpread({}, this.node.attrs, newAttrs);

        this.node.attrs = attrs;
        tr.setNodeMarkup(pos, null, attrs);
      } catch (error) {
        console.error(error);
      }

      dispatch(tr);
      return this.view.nodeDOM(pos);
    };

    this.getToolbar = ({
      color,
      pattern,
      expand
    }) => {
      return preact.h(StatusEditor, {
        color: color,
        pattern: pattern,
        expand: expand,
        handleColorSelect: this.handleColorSelect,
        handlePatternSelect: this.handlePatternSelect,
        handleExpand: this.handleExpand,
        hidePopover: this.hidePopover
      });
    };
  }

  init(editor) {
    this.editor = editor;
    this.view = editor.view;
  }

}

function wash(body) {
  return body.replace(/(<span class="ct-status"[^>]+>)/g, '$1\u200B');
}

var css$2 = ".ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:\"\";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}";
styleInject(css$2);

const toView = ({
  bodyWrapper
}) => {
  const nodes = bodyWrapper.querySelectorAll(".ct-status");
  Array.from(nodes).forEach(node => {
    const {
      color = "#ccc",
      pattern = "fill"
    } = node.dataset;
    const formattedColor = formatOldValue(color);
    node.setAttribute("style", computeStyle(formattedColor, pattern));
  });
};

class StatusModule {
  constructor() {
    this.name = "status";
    this.store = void 0;
    this.schema = void 0;
    this.commands = void 0;
    this.plugins = void 0;
    this.wash = void 0;
    this.store = new StatusStore();
    this.schema = schema;
    this.commands = {
      insert: () => insert(),
      setAttrs
    };
    this.plugins = [createPlugin(this.store), keymap({
      "Backspace": handleBackspace,
      "Mod-Backspace": handleBackspace,
      "Delete": handleBackspace,
      "Mod-Delete": handleBackspace,
      "Enter": handleEnter,
      "Tab": handleEnter
    })];
    this.wash = wash;
  }

  init(editor) {
    this.store.init(editor);
  }

}
StatusModule.moduleName = "status";

exports.StatusModule = StatusModule;
exports.toView = toView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/status/index.js